import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import ChequeAddForm from "../../components/Cheque/Add/ChequeAddForm";

const ChequeRepeatePage = (props) => {
  const { data } = props;

  const newData = { ...data };
  delete newData.id;

  return (
    <Wrapper>
      <ChequeAddForm data={newData} isRepeat={true} />
    </Wrapper>
  );
};

export default ChequeRepeatePage;
